import { render, staticRenderFns } from "./VideoPostCard.vue?vue&type=template&id=32302b43&scoped=true&"
import script from "./VideoPostCard.vue?vue&type=script&lang=ts&"
export * from "./VideoPostCard.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPostCard.vue?vue&type=style&index=0&id=32302b43&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32302b43",
  null
  
)

export default component.exports